import { useTheme } from '@mui/material';

export const IntroIcon6 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            className={className}
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8 13C8 11.8954 8.89543 11 10 11H34C36.2091 11 38 12.7909 38 15V29C38 31.2091 36.2091 33 34 33H12C9.79086 33 8 31.2091 8 29V13Z"
                fill={primaryBackground}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 9.5H31C32.3807 9.5 33.5 10.6193 33.5 12V26C33.5 27.3807 32.3807 28.5 31 28.5H9C7.61929 28.5 6.5 27.3807 6.5 26V12C6.5 10.6193 7.61929 9.5 9 9.5ZM5 12C5 9.79086 6.79086 8 9 8H31C33.2091 8 35 9.79086 35 12V26C35 28.2091 33.2091 30 31 30H9C6.79086 30 5 28.2091 5 26V12ZM9.83542 11.8292C9.46494 11.6439 9.01443 11.7941 8.82919 12.1646C8.64395 12.5351 8.79412 12.9856 9.1646 13.1708L19.2259 18.2015C20.0341 18.6056 20.9893 18.5869 21.781 18.1514L30.8615 13.1572C31.2244 12.9576 31.3568 12.5015 31.1572 12.1386C30.9576 11.7756 30.5015 11.6432 30.1386 11.8428L21.0581 16.8371C20.6983 17.035 20.2641 17.0435 19.8967 16.8598L9.83542 11.8292ZM12.416 21.876C12.7607 22.1057 12.8538 22.5714 12.624 22.916L10.624 25.916C10.3943 26.2607 9.92861 26.3538 9.58396 26.124C9.23932 25.8943 9.14619 25.4286 9.37595 25.084L11.376 22.084C11.6057 21.7393 12.0714 21.6462 12.416 21.876ZM27.376 22.916C27.1462 22.5714 27.2393 22.1057 27.584 21.876C27.9286 21.6462 28.3943 21.7393 28.6241 22.084L30.6241 25.084C30.8538 25.4286 30.7607 25.8943 30.416 26.124C30.0714 26.3538 29.6057 26.2607 29.376 25.916L27.376 22.916Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
